<template>
  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center">
            <b>Atividades</b>
          </h5>
        </th>
      </tr>

      <tr>
        <td colspan="4">
          <load
              mode="table"
              v-if="loadingAtividades"
          />

          <div
              class="col-md-12"
              v-else
          >
            <b-table
                :fields="[
                  {
                    key: 'detalhes',
                    label: $t('Detalhes'),
                  },
                  {
                    key: 'data_participacao',
                    label: $t('Data da participação'),
                  },
                ]"
                :items="atividadesList"
                :responsive="true"
                striped
                hover
                show-empty
                small
                outlined
                stacked="xs"
                table-class="mb-3"
            >
              <template v-slot:cell(detalhes)="data">
                Nome da atividade:
                <b>{{ data.item.titulo }}</b>

                <br>

                Protocolo:
                <b>{{ data.item.protocolo }}</b>

                <br>

                Tipo:
                <b>{{ data.item.tipo_descricao || "-" }}</b>

                <br>

                Situação:
                <b>{{ situacaoPresenca(data.item.presenca) }}</b>
              </template>

              <template v-slot:cell(data_participacao)="data">
                <b>{{ data.item.data_participacao || "" }}</b>
              </template>

              <template v-slot:empty>
                <div class="text-center my-5">
                  <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                  />

                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Atividades",

  props: {
    usuario: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      atividadesList: [],
      loadingAtividades: true,
    };
  },

  mounted() {
    this.getAtividades();
  },

  methods: {
    getAtividades() {
      this.loadingAtividades = true;

      axios
          .get(
              `api/dashboard/print/usuarios/atividades/${this.usuario}`
          )
          .then((response) => {
            this.atividadesList = response.data.data || [];
          })
          .catch(() => {
            this.atividadesList = [];
          })
          .finally(() => {
            this.loadingAtividades = false;
          });
    },

    situacaoPresenca(presenca) {
      return Number(presenca) === 1
          ? "PRESENTE"
          : "AUSENTE";
    },
  },
};
</script>

<style scoped>
</style>